var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.$store.getters['layout/offset'] > 50)?_c('b-button',{staticClass:"p-1",attrs:{"variant":"link","href":"/"}},[_c('b-img-lazy',{staticClass:"logo-a",attrs:{"src":_vm.$config.cdnEndpoint + 'front/loghi/vp.svg',"alt":"Logo piccolo"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }